import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalHook() {
  return <section className="py-20 bg-[#FAF3E0]" data-id="element-70">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-72">
          <h2 className="text-3xl md:text-5xl text-[#0E3B26] mb-8 font-[800]" data-id="element-73">
            ¿TE PASA ESTO CON EL ÁLBUM DE TU HIJO?
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-800 font-medium leading-relaxed" data-id="element-74">
            <p data-id="element-75">
              Comprás un paquete. Vienen{' '}
              <span className="bg-wc-yellow px-1 font-bold rounded" data-id="element-76">
                las mismas de siempre
              </span>
              .<br data-id="element-77" />
              Comprás otro.{' '}
              <span className="bg-wc-yellow px-1 font-bold rounded" data-id="element-78">
                Repetidas otra vez
              </span>
              .<br data-id="element-79" />
              <span className="inline-block bg-wc-red text-white px-3 py-1 rounded-lg font-bold mt-2" data-id="element-80">
                El álbum sigue vacío.
              </span>{' '}
              Los pesos se fueron.
            </p>

            <p data-id="element-81">Tu hijo te mira con esa cara y vos ya sabés lo que viene:</p>

            <p className="text-wc-red font-bold italic text-2xl" data-id="element-82">
              "¿Me comprás más figuritas?"
            </p>

            <p data-id="element-83">
              No es que no quieras. Es que el sistema de los paquetes está
              diseñado exactamente para que{' '}
              <span className="inline-block bg-wc-red text-white px-3 py-1 rounded-lg font-bold" data-id="element-84">
                nunca puedas completarlo
              </span>
              .
            </p>

            <p className="font-[800]" data-id="element-85">
              Calcularon bien: necesitas mas de $430.000 en paquetes de
              figuritas, nuestro Pack $15.990 imprimís y LISTO completas el
              álbum
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}